var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.125 15H1.875C0.8375 15 0 14.1625 0 13.125V1.875C0 0.8375 0.8375 0 1.875 0H18.125C19.1625 0 20 0.8375 20 1.875V13.125C20 14.1625 19.1625 15 18.125 15ZM1.875 1.25C1.525 1.25 1.25 1.525 1.25 1.875V13.125C1.25 13.475 1.525 13.75 1.875 13.75H18.125C18.475 13.75 18.75 13.475 18.75 13.125V1.875C18.75 1.525 18.475 1.25 18.125 1.25H1.875Z",
    fill: "#DE1186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0001 9.95003C9.12506 9.95003 8.32506 9.60003 7.72506 8.96253L1.16256 1.98753C0.925057 1.73753 0.937557 1.33753 1.18756 1.10003C1.43756 0.862526 1.83756 0.875026 2.07506 1.12503L8.63756 8.10003C9.35006 8.86253 10.6501 8.86253 11.3626 8.10003L17.9251 1.13753C18.1626 0.887526 18.5626 0.875026 18.8126 1.11253C19.0626 1.35003 19.0751 1.75003 18.8376 2.00003L12.2751 8.97503C11.6751 9.61253 10.8751 9.96253 10.0001 9.96253V9.95003Z",
    fill: "#DE1186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActiveIcon);
export default __webpack_public_path__ + "static/media/message-active-icon.c97c7d676f877b6a3efc1063eda058d1.svg";
export { ForwardRef as ReactComponent };